<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Economic Code *"
                  v-model="formSchema.eco_account_code"
                  :rules="[v => !!v || 'Economic code is required !', lng10]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Economic Name *"
                  v-model="formSchema.eco_account_name"
                  :rules="[v => !!v || 'Economic name is required !', lng100]"
                  required
                ></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Budget Type *"
                  v-model="formSchema.root_name"
                  :items="rootNameList"
                  :rules="[v => !!v || 'Budget type is required !']"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Code Type *"
                  v-model="formSchema.head_type"
                  :items="headTypeList"
                  :rules="[v => !!v || 'Code type is required !']"
                  required
                ></v-autocomplete>
              </v-flex>

              

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Economic Type *"
                  v-model="formSchema.account_type"
                  :items="accountTypeList"
                  :rules="[v => !!v || 'Economic type is required !']"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Project Component"
                  v-model="formSchema.project_component"
                  :items="projectComponentList"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Category"
                  v-model="formSchema.category"
                  :items="categoryList"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Unit"
                  v-model="formSchema.unit"
                  :items="economicUnit"    
                  clearable
            single-line hide-details                
                ></v-autocomplete>
              </v-flex>

              <!-- <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Service Type"
                  v-model="formSchema.service_type"
                  :items="serviceTypeList"
                  required
                ></v-autocomplete>
              </v-flex> -->

              <v-flex xs12 sm6 md4>
                Upload File
                <input
                type="file"
                id="files2"
                ref="image2"
                v-on:change="handleFilesUpload()"
                />
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid"><v-icon>save</v-icon>  {{addUpdateBtn}}</v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon> Reset</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");

export default {
  props: ["formSchema"],
  data: () => ({
    valid: true,    
    isActiveVal:1,
    documentFiles:[], 
    
    rootNameList: utilities.getRootNameList(),
    headTypeList: utilities.getHeadTypeList(),
    accountTypeList: utilities.getAccountTypeList(),
    projectComponentList: utilities.getProjectComponentList(),
    categoryList: utilities.getCategoryList(),
    serviceTypeList: utilities.getServiceTypeList(),    
    economicUnit: utilities.getEconomicUnit()
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Economic Code Information"
        : "Add Economic Code Information";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0
        ? "Update"
        : "Save";
    }
  },

  created() {
    // commonService.getAllData("operation-activities").then(res => {
    //   if (res.status == "success") {    
    //   }
    // });
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    validateBeforeSubmit(e) {

      let formData = new FormData();
      var formSchema = this.formSchema;      

      for (var i = 0; i < this.documentFiles.length; i++) {
        let file = this.documentFiles[i];
        formData.append("files[" + i + "]", file);
      } 

      formData.append("fieldValues", JSON.stringify(formSchema));
      formData.append('method','put');

      let docInfor = {
        "record_id":sessionStorage.getItem("mm_id"),
        "sub_menu_id":sessionStorage.getItem("sm_id"),
      };
      formData.append("documentInfo", JSON.stringify(docInfor));

      if (this.$refs.form.validate()) {
          commonService
            .insertFormData(formData, "economy-code-info")
            .then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: res.action,
                status: res.status
              };
              document.getElementById("files2").value = null;
              this.close(actionData);
            });
      }
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("fileExtension", fileExtension);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.PDF|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {

       this.SnackbarVal.message = "You can upload jpg, jpeg, png, pdf and docx file only";
       this.SnackbarVal.snackbar = true;
       this.SnackbarVal.color = 'error';

        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        //console.log("uploadedFiles[i] = ", uploadedFiles[0]);

        this.documentFiles = uploadedFiles;

        // for (var i = 0; i < uploadedFiles.length; i++) {
        //   this.documentFiles.push(uploadedFiles[i]);
        // }
      }
    },

    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/project_info/economy_code_info/insertForm.vue